import { z } from 'zod';

export const pagedBodyParamsSchema = z.object({
    page: z.number(),
    size: z.number(),
});

export type PagedBodyParams = z.infer<typeof pagedBodyParamsSchema>;

export const sortedBodyParamsSchema = z.object({
    fields: z
        .object({
            direction: z.enum(['asc', 'desc']).optional(),
            field: z.string(),
            nullsFirst: z.boolean().optional(),
        })
        .array(),
});

export type SortedBodyParams = z.infer<typeof sortedBodyParamsSchema>;

export type SortedField = {
    readonly direction?: 'asc' | 'desc';
    readonly field: string;
    readonly nullsFirst?: boolean;
};

export type Mutation<T> = { readonly [K in keyof T]: T[K] | null };

export const CustomFieldPrefix = 'custom.';

export const exportFileSchema = z.object({
    downloadLink: z.url(),
});

export type ExportFile = z.infer<typeof exportFileSchema>;
